module.exports = __webpack_public_path__ + "static/img/user.7d567ee3.jpg";